var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.75 11.75V14.75C15.75 15.1478 15.592 15.5294 15.3107 15.8107C15.0294 16.092 14.6478 16.25 14.25 16.25H3.75C3.35218 16.25 2.97064 16.092 2.68934 15.8107C2.40804 15.5294 2.25 15.1478 2.25 14.75V11.75","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.75 6.5L9 2.75L5.25 6.5","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M9 2.75V11.75","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Upload.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = Upload;

Upload.default = Upload;
